import { axiosPut } from 'shared/api/axios'

const reorderAll = async (endpoint: string, data: Array<number>) => {
  const requestParams = { order: data }

  const catchFn = (error) => {
    return false
  }

  const response = await axiosPut(endpoint, requestParams, catchFn)
  return response
}

export default reorderAll
